
export const TipoDataObrigatoriedade =
{
    guias: 1,
    atividade: 2,
}






